import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { Text, Container, Image } from '@weareconceptstudio/core';
import Breadcrumb from '@/components/Breadcrumb';

//* Style
import HeroStyle from './style';

//* Animation
import { animationTitle } from '@/helpers/_animationTitle';

const Hero = ({ title, image, setIsLoading, isLoading }) => {
	//! Ref
	const titleRef = useRef();
	const refSplitText = useRef();

	useEffect(() => {
		if (isLoading) {
			gsap.to('.wrapper-image', { scale: 1, duration: 0.7, ease: 'power2.out' });
			animationTitle({ element: titleRef.current, ref: refSplitText, duration: 0.7, delay: 0.2 });
		}

		return () => {
			refSplitText.current?.revert();
		};
	}, [isLoading]);

	return (
		<HeroStyle>
			<div className='wrapper-hero'>
				<div className='wrapper-image'>
					<Image
						onLoad={setIsLoading}
						src={image.src}
						alt={image.alt}
					/>
				</div>
				<div className='breadcrumb-wrapper'>
					<Breadcrumb
						name={'ourBlog'}
						breadcrumbs={[{ name: title }]}
					/>
				</div>

				<div className={'wrapper-title'}>
					<Container
						row
						full>
						<div className='empty col-2 col-t-1' />

						<div className={'wrapper-title-inner col-8 col-t-10 col-m-12'}>
							<Text
								ref={titleRef}
								tag={'h1'}
								className={'h3 font-montserrat-arm-medium opacity-zero'}>
								{title}
							</Text>
						</div>

						<div className='empty col-2 col-t-1' />
					</Container>
				</div>
			</div>
		</HeroStyle>
	);
};

export default Hero;
